import get from 'lodash/get';
import { getCookie } from '../../utils/cookie';
import { hasInteractedWithCcpaOptOutSettingsCookie } from '../../constants/cookies';
import jurisdictions from '../consent/constants/jurisdictions';
import {
  AUTO_DATA_OPT_OUT,
  SHOW_DATA_OPT_OUT,
  JURISDICTION,
} from '../../constants/terms';
import {
  DATA_OPT_OUT_ENABLED,
  DONT_SELL_MY_DATA_ENABLED,
} from '../../constants/experiments/ads';
import { isUserOptedOutUnderCcpa } from '../../utils/optOut/checkUserOptOutStatus';

/**
 * Util which is used to make a decision on whether ccpa opt out should be shown based on:
 * dataOptOutEnabled - ccpaSpecific clientSide config
 * autoDataOptOut - age-based auto opt out flag
 * showDataOptOut - shouldShowDataOptOut platform flag
 * userJurisdiction - user's jurisdiction (ccpa, global, gdpr, ...)
 * hasInteractedWithCcpaOptOutSettingsCookie - have the settings ever been changed on the CCPA page
 * ccpaOptOutCookie - is the ccpa cookie set to true
 * @param config - app config
 * @param ignoreAutoDataOptOut - ignores autoDataOptOutFlag
 * @returns {*|boolean}
 */
export function shouldShowCcpaOptOut(config, ignoreAutoDataOptOut) {
  const dataOptOutEnabled = get(config, ['autoupdate', DATA_OPT_OUT_ENABLED]);
  const autoDataOptOut = ignoreAutoDataOptOut
    ? false
    : get(config, ['terms', AUTO_DATA_OPT_OUT]);
  const showDataOptOut = get(config, ['terms', SHOW_DATA_OPT_OUT]);
  const userJurisdiction = get(config, ['terms', JURISDICTION]);

  return (
    dataOptOutEnabled &&
    !autoDataOptOut &&
    (getCookie(hasInteractedWithCcpaOptOutSettingsCookie.name) === true ||
      isUserOptedOutUnderCcpa() ||
      (showDataOptOut && userJurisdiction === jurisdictions.ccpa))
  );
}

/**
 * Util which is used to make a decision on whether ccpa policy link is shown based on:
 * userJurisdiction - must be in ccpa jursdiction
 * autoDataOpOut - age-based auto opt out flag
 * dontSellMyDataEnabled - client side config flag for the ccpa policy link
 * @param config
 * @returns {*|*|boolean}
 */
export function shouldShowCcpaPolicyPageLink(config) {
  const dontSellMyDataEnabled = get(config, [
    'autoupdate',
    DONT_SELL_MY_DATA_ENABLED,
  ]);
  const autoDataOptOut = get(config, ['terms', AUTO_DATA_OPT_OUT]);
  const userJurisdiction = get(config, ['terms', JURISDICTION]);

  return (
    dontSellMyDataEnabled &&
    autoDataOptOut &&
    userJurisdiction === jurisdictions.ccpa
  );
}
